import { useState } from "react";
import axios from "axios";


const ContactForm = () => {
 
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    hearAboutUs: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/api/sendEmail", formData);
      console.log("Message sent", response);
    } catch (error) {
      console.error("Error sending message", error);
    }
  };

  return (
   <form onSubmit={handleSubmit} className="space-y-6 px-4 sm:px-0 ">
  <div
    className="flex flex-col items-center justify-center gap-14 w-full sm:w-[556px] mx-auto relative"
  >
    <div className="flex flex-col items-start gap-4 w-full">
      {/* First & Last Name */}
      <div className="flex flex-row   items-center gap-4 w-full">
        <div className="flex flex-col gap-3 w-full ">
          <input
            className="w-full h-12 px-4 rounded-lg border border-neutral-300 font-outfit text-base text-[#6f6f6f] outline-none focus:border-[#9abb7a]"
            placeholder="First name"
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="flex flex-col gap-3 w-full">
          <input
            className="w-full h-12 px-4 rounded-lg border border-neutral-300 font-outfit text-base text-[#6f6f6f] outline-none focus:border-[#9abb7a]"
            placeholder="Last name"
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      {/* Phone Number */}
      <div className="flex flex-col gap-3 w-full">
        <label className="text-left font-outfit text-[#6f6f6f] text-base">
          Phone number
        </label>
        <div className="flex h-12 items-center w-full border border-neutral-300 rounded-lg overflow-hidden">
          <span className="px-3 border-r border-neutral-300 text-[#6f6f6f]">+91</span>
          <input
            className="flex-1 h-full px-4 outline-none font-outfit text-base text-[#6f6f6f]"
            type="tel"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      {/* Email */}
      <div className="flex flex-col gap-3 w-full">
        <input
          className="w-full h-12 px-4 rounded-lg border border-neutral-300 font-outfit text-base text-[#6f6f6f] outline-none focus:border-[#9abb7a]"
          placeholder="Email address"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      {/* How did you hear about us */}
      <div className="flex flex-col gap-3 w-full">
        <label className=" text-left font-outfit text-[#6f6f6f] text-base">
          How did you first hear about us
        </label>
        <textarea
          className="w-full h-[125px] p-4 rounded-lg border border-neutral-300 font-outfit text-base text-[#6f6f6f] outline-none focus:border-[#9abb7a] resize-none"
          name="hearAboutUs"
          value={formData.hearAboutUs}
          onChange={handleChange}
          required
        />
      </div>
    </div>

    {/* Submit Button */}
   {/* Submit Button */}
<div className="w-full flex justify-end">
  <button 
    type="submit"
    className="w-[96px] h-[36px] lg:w-[140px] lg:h-[48px] flex items-center justify-center px-3 py-2.5 bg-[#9abb7a] rounded text-white font-outfit hover:bg-[#8ba96d] transition-colors duration-300"
  >
    Submit
  </button>
</div>

  </div>
</form>

  );
};

export default ContactForm;
